import { Modal, Tabs } from 'antd'
import Button from 'components/Button/index'
import RoutePath from 'components/RoutePath'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import LeftArrow from 'components/icons/LeftArrow'
import { StyledTabs, TabLeftDiv } from 'modules/ManageProfile/Styles/style'
import RoleStatus from 'modules/Roles/Partials/RolesTable/RoleStatus/index'
import {
  LeftSection,
  PaddedDiv,
  RoleNameDiv,
  RoleNameFlex,
  SectionName,
  SummaryButton,
  TopEndFlex,
  TopHeader,
} from 'modules/Roles/ViewRole/Style/style'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Individualindex from '../../../ViewRole/Header/QuestionaireDashboard/IndividualPage/index'
import Overviewindex from '../../../ViewRole/Header/QuestionaireDashboard/OverViewpage/index'
import QuestionaireTable from './CandidatesPage'
import CandidateModal from './CandidatesPage/Partials/CandidateModal'
import Metrics from './CandidatesPage/Partials/Metrics'

const { TabPane } = Tabs

const Dashboardindex = ({
  singleRoleData,
  graphList,
  questionaireDBList,
  getQuestionaireGraphList,
  getIndividualDrawerList,
  individualDrawerQuestion,
  getStudentQuestionaireList,
  getQuestionnaireDetails,
  getCandidateDetails,
  getPromotion,
  promotionData,
  candidateDetails,
  qbBasedCollegeList,
  qbsBasedDegreeList,
  getCollegeBasedOnQuestionnier,
  getDegreeBasedOnQuestionnier,
  getQuestionAndAnswerList,
  questionnaireData,
}) => {
  const [individualComponentVisible, setIndividualComponentVisible] =
    useState(false)
  const [overviewComponentVisible, setOverviewComponentVisible] = useState(true)
  const [selectedRound, setSelectedRound] = useState('Applied Candidates')
  const [searchValue, setSearchValue] = useState('')
  const [loading, setLoading] = useState(false)
  const [content, setContent] = useState(false)
  const [text, setText] = useState(false)
  const [selected, setSelected] = useState(true)
  const [sortBy, setSortBy] = useState('')
  const [tab, setTab] = useState('Summary')
  const [orderBy, setOrderBy] = useState('')
  const [pageNum, setPageNum] = useState(0)
  const [currentPage, setCurrentPage] = useState(0)
  const [count, setCount] = useState(1)
  const [drawerStatus, setDrawerStatus] = useState('')
  const [viewDrawer, setViewDrawer] = useState(false)
  const [selectedId, setSelectedId] = useState('')
  const [countDrive, setCountDrive] = useState(0)
  const [countDriveSummary, setCountDriveSummary] = useState(0)
  const [college, setCollege] = useState('')

  const rolesMetrics = [
    { name: 'Applied Candidates', count: questionaireDBList?.totalCount },
    {
      name: 'Shortlisted Candidates',
      count: questionaireDBList?.shortListedCount,
    },
    { name: 'Rejected Candidates', count: questionaireDBList?.rejectedCount },
  ]

  let pageLimit = 10
  const [checkedIds, setCheckedIds] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])

  const [candidateFilterData, setCandidateFilterData] = useState({
    rating: '',
    yearOfEx: '',
    degreeDepartment: '',
    instituteCampusIds: '',
    degreekeys: '',
    location: '',
    latestCompany: '',
    latestRole: '',
  })

  const handleIndividualClick = () => {
    setIndividualComponentVisible(true)
    setOverviewComponentVisible(false)
    getQuestionaireGraphList({ roleId: params?.jobId, type: 'INDIVIDUAL' })
  }

  const handleOverviewClick = () => {
    setIndividualComponentVisible(false)
    setOverviewComponentVisible(true)
    getQuestionaireGraphList({ roleId: params?.jobId, type: 'OVERVIEW' })
  }
  useEffect(() => {
    setIndividualComponentVisible(false)
    setOverviewComponentVisible(true)
    getQuestionaireGraphList({ roleId: params?.jobId, type: 'OVERVIEW' })
  }, [])
  const [showButtons, setShowButtons] = useState(false)
  const [candidateStatus, setCandidateStatus] = useState('')
  const [filterStatus, setFilterStatus] = useState('')

  const onChange = activeKey => {
    setTab(activeKey)
    setSelectedRound('Applied Candidates')
    setShowButtons(activeKey === 'Candidates')
    setCandidateStatus('')
    fetchCandidateData()
  }
  const params = useParams()

  useEffect(() => {
    getCollegeBasedOnQuestionnier({ jobId: params?.jobId })
    getDegreeBasedOnQuestionnier({ jobId: params?.jobId })
  }, [params?.jobId])

  const handleShortlistClick = () => {
    showModal('shortlist')
  }

  const handleRejectClick = () => {
    showModal('reject')
  }

  const handleSort = (page, search, filter) => {
    if (filter?.order) {
      let sort = filter?.order == 'ascend' ? 'asc' : 'desc'
      setSortBy(filter?.field)
      setOrderBy(sort)
    } else {
      setOrderBy('')
      setSortBy('')
    }
  }

  const [modalVisible, setModalVisible] = useState(false)
  const [modalActionType, setModalActionType] = useState('') // Add this line

  const showModal = actionType => {
    setModalVisible(true)
    setModalActionType(actionType)
  }

  const closeModal = () => {
    setModalVisible(false)
  }

  const fetchCandidateData = async () => {
    let { data, statuses } = await getStudentQuestionaireList({
      roleId: params?.jobId,
      setLoading,
      status: candidateStatus,
      searchValue,
      filterData: candidateFilterData,
      sortby: sortBy,
      orderby: orderBy,
      pageNum: pageNum,
      pageLimit: pageLimit,
      checkedIds: checkedIds,
      isExpCandidate: singleRoleData?.jobTypeLevels?.[0] == 'EXPERIENCED',
    })

    if (statuses >= 400) {
      ErrorMessage(data?.message)
    }
  }

  const fetchCandidateDataNew = async () => {
    let { data, statuses } = await getStudentQuestionaireList({
      roleId: params?.jobId,
      setLoading,
      status: candidateStatus,
      searchValue,
      filterData: candidateFilterData,
      sortby: sortBy,
      orderby: orderBy,
      pageNum: 0,
      pageLimit: pageLimit,
      checkedIds: checkedIds,
      isExpCandidate: singleRoleData?.jobTypeLevels?.[0] == 'EXPERIENCED',
    })

    if (statuses >= 400) {
      ErrorMessage(data?.message)
    }
  }

  useEffect(() => {
    let getData
    if (searchValue) {
      getData = setTimeout(() => {
        fetchCandidateData()
      }, 500)
    } else {
      fetchCandidateData()
      getQuestionnaireDetails(
        params?.jobId,
        candidateStatus,
        singleRoleData?.jobTypeLevels?.[0] == 'EXPERIENCED'
      )
    }
    return () => clearTimeout(getData)
  }, [sortBy, orderBy, pageNum, currentPage, count, candidateStatus])

  useEffect(() => {
    setPageNum(0)
    setCount(prev => prev + 1)
  }, [candidateFilterData, searchValue])

  const onPageChange = value => {
    setPageNum(value)
    setContent(true)
    setText(false)

    setSelectedRowKeys([])
  }
  const onClickShortlist = () => {
    showModal(drawerStatus == -1 ? 'shortlist' : 'reject')
    setSelectedRowKeys([selectedId])
  }
  return (
    <PaddedDiv column>
      <TopHeader row spaceBetween alignCenter>
        <LeftSection centerVertically>
          <Link
            to={`/roles/${params?.jobId}/${
              singleRoleData?.jobTypeLevels?.[0] === 'EXPERIENCED'
                ? 'ex-student'
                : 'view-role'
            }`}
          >
            <LeftArrow />
          </Link>
          <SectionName column>
            <RoutePath
              from="View Role"
              on={'Summary'}
              path={`/roles/${params?.jobId}/${
                singleRoleData?.jobTypeLevels?.[0] === 'EXPERIENCED'
                  ? 'ex-student'
                  : 'view-role'
              }`}
            />

            <RoleNameFlex alignCenter>
              <RoleNameDiv>Questionnaire Overview</RoleNameDiv>
              <RoleStatus status={singleRoleData?.status} />
            </RoleNameFlex>
          </SectionName>
        </LeftSection>
        {showButtons && (
          <TopEndFlex alignCenter>
            {selectedRound == 'Rejected Candidates' &&
              questionaireDBList?.result?.length > 0 && (
                <div style={{ paddingRight: '20px', paddingTop: '20px' }}>
                  <Button.Secondary
                    height={'38px'}
                    text={'Shortlist'}
                    style={{ backgroundColor: '#3249D7', color: 'white' }}
                    onClick={handleShortlistClick}
                    disabled={selectedRowKeys?.length == 0}
                    title={
                      selectedRowKeys?.length === 0
                        ? 'Please select the candidate to shortlist'
                        : ''
                    }
                  />
                </div>
              )}
            {selectedRound == 'Shortlisted Candidates' &&
              questionaireDBList?.result?.length > 0 && (
                <div style={{ paddingRight: '20px', paddingTop: '20px' }}>
                  <Button.Secondary
                    height={'38px'}
                    text={'Reject'}
                    style={{ backgroundColor: '#E35E50', color: 'white' }}
                    onClick={handleRejectClick}
                    disabled={selectedRowKeys?.length == 0}
                    title={
                      selectedRowKeys?.length === 0
                        ? 'Please select the candidate to reject'
                        : ''
                    }
                  />
                </div>
              )}
          </TopEndFlex>
        )}
      </TopHeader>
      <TabLeftDiv>
        <StyledTabs defaultActiveKey="Summary" onChange={onChange}>
          <TabPane tab="Summary" key="Summary">
            <SummaryButton>
              {overviewComponentVisible ? (
                <Button.Primary
                  height={'38px'}
                  text={'Overview'}
                  style={{ borderColor: '#3249D7', padding: '20px' }}
                  onClick={handleOverviewClick}
                />
              ) : (
                <Button.Secondary
                  height={'38px'}
                  text={'Overview'}
                  style={{ borderColor: '#3249D7', padding: '20px' }}
                  onClick={handleOverviewClick}
                />
              )}
              {individualComponentVisible ? (
                <Button.Primary
                  height={'38px'}
                  text={'Individual'}
                  style={{ borderColor: '#3249D7', padding: '20px' }}
                  onClick={handleIndividualClick}
                />
              ) : (
                <Button.Secondary
                  height={'38px'}
                  text={'Individual'}
                  style={{ borderColor: '#3249D7', padding: '20px' }}
                  onClick={handleIndividualClick}
                />
              )}
            </SummaryButton>
            <div>
              {individualComponentVisible && (
                <Individualindex
                  graphList={graphList?.individual}
                  isVisible={graphList?.isCandFound}
                  getQuestionaireGraphList={getQuestionaireGraphList}
                  jobId={params?.jobId}
                  getIndividualDrawerList={getIndividualDrawerList}
                  individualDrawerQuestion={individualDrawerQuestion}
                  singleRoleData={singleRoleData}
                  getCandidateDetails={getCandidateDetails}
                  getPromotion={getPromotion}
                  promotionData={promotionData}
                  candidateDetails={candidateDetails}
                  getQuestionAndAnswerList={getQuestionAndAnswerList}
                  setCountDriveSummary={setCountDriveSummary}
                  countDriveSummary={countDriveSummary}
                />
              )}
              {overviewComponentVisible && (
                <Overviewindex
                  data={graphList?.overview}
                  isVisible={graphList?.isCandFound}
                />
              )}
            </div>
          </TabPane>
          {}
          <TabPane tab="Candidates" key="Candidates">
            <div style={{ paddingBottom: '20px', paddingTop: '10px' }}>
              <Metrics
                rolesMetrics={rolesMetrics}
                selectedRound={selectedRound}
                setCurrentPage={setCurrentPage}
                setSelectedRound={setSelectedRound}
                setCandidateStatus={setCandidateStatus}
                candidateStatus={candidateStatus}
                setSelectedRowKeys={setSelectedRowKeys}
                setPageNum={setPageNum}
                questionaireDBList={questionaireDBList}
                singleRoleData={singleRoleData}
                setCollege={setCollege}
                college={college}
                setCandidateFilterData={setCandidateFilterData}
                setSearchValue={setSearchValue}
              />
            </div>
            <QuestionaireTable
              qbsBasedDegreeList={qbsBasedDegreeList}
              qbBasedCollegeList={qbBasedCollegeList}
              setFilterStatus={setFilterStatus}
              filterStatus={filterStatus}
              selectedRound={selectedRound}
              setSearchValue={setSearchValue}
              setCandidateFilterData={setCandidateFilterData}
              candidateFilterData={candidateFilterData}
              searchValue={searchValue}
              handleSort={handleSort}
              pageNum={pageNum}
              pageLimit={pageLimit}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              questionaireDBList={questionaireDBList}
              onPageChange={onPageChange}
              setContent={setContent}
              content={content}
              setSelected={setSelected}
              selected={selected}
              setLoading={setLoading}
              loading={loading}
              singleRoleData={singleRoleData}
              getCandidateDetails={getCandidateDetails}
              getPromotion={getPromotion}
              promotionData={promotionData}
              candidateDetails={candidateDetails}
              setCheckedIds={setCheckedIds}
              checkedIds={checkedIds}
              setSelectedRowKeys={setSelectedRowKeys}
              selectedRowKeys={selectedRowKeys}
              roleId={params?.jobId}
              getQuestionAndAnswerList={getQuestionAndAnswerList}
              onClickShortlist={onClickShortlist}
              setDrawerStatus={setDrawerStatus}
              setSelectedId={setSelectedId}
              selectedId={selectedId}
              drawerStatus={drawerStatus}
              setViewDrawer={setViewDrawer}
              viewDrawer={viewDrawer}
              setPageNum={setPageNum}
              questionnaireData={questionnaireData}
              setText={setText}
              text={text}
              setCountDrive={setCountDrive}
              countDrive={countDrive}
              college={college}
              setCollege={setCollege}
            />
          </TabPane>
          {}
        </StyledTabs>
      </TabLeftDiv>
      <Modal
        visible={modalVisible}
        centered
        closable={false}
        footer={null}
        width={670}
        onClose={closeModal}
      >
        <CandidateModal
          questionaireDBList={questionaireDBList}
          onClose={closeModal}
          actionType={modalActionType}
          setSelectedRowKeys={setSelectedRowKeys}
          selectedRowKeys={selectedRowKeys}
          fetchCandidateData={fetchCandidateDataNew}
          setViewDrawer={setViewDrawer}
          setText={setText}
          text={text}
          tab={tab}
          setCountDrive={setCountDrive}
          countDrive={countDrive}
          setPageNum={setPageNum}
        />
      </Modal>
    </PaddedDiv>
  )
}

export default Dashboardindex
